import api from './client';
import { DiseaseGroup, Disease } from '../types/diseases';

export const diseaseGroupsApi = {
  getAll: async (): Promise<DiseaseGroup[]> => {
    const response = await api.get<DiseaseGroup[]>('/diseases/groups');
    return response.data;
  },

  getById: async (id: number): Promise<DiseaseGroup> => {
    const response = await api.get<DiseaseGroup>(`/diseases/groups/${id}`);
    return response.data;
  },

  create: async (data: Omit<DiseaseGroup, 'id' | 'createdAt' | 'updatedAt'>): Promise<DiseaseGroup> => {
    const response = await api.post<DiseaseGroup>('/diseases/groups', data);
    return response.data;
  },

  update: async (id: number, data: Partial<DiseaseGroup>): Promise<DiseaseGroup> => {
    const response = await api.put<DiseaseGroup>(`/diseases/groups/${id}`, data);
    return response.data;
  },

  delete: async (id: number): Promise<void> => {
    await api.delete<void>(`/diseases/groups/${id}`);
  },
};

export const diseasesApi = {
  getAll: async (): Promise<Disease[]> => {
    const response = await api.get<Disease[]>('/diseases');
    return response.data;
  },

  getById: async (id: number): Promise<Disease> => {
    const response = await api.get<Disease>(`/diseases/${id}`);
    return response.data;
  },

  create: async (data: Omit<Disease, 'id' | 'createdAt' | 'updatedAt' | 'group' | 'medicines'>): Promise<Disease> => {
    const response = await api.post<Disease>('/diseases', data);
    return response.data;
  },

  update: async (id: number, data: Partial<Disease>): Promise<Disease> => {
    const response = await api.put<Disease>(`/diseases/${id}`, data);
    return response.data;
  },

  delete: async (id: number): Promise<void> => {
    await api.delete<void>(`/diseases/${id}`);
  },

  search: async (query: string): Promise<Disease[]> => {
    const response = await api.get<Disease[]>(`/diseases/search?q=${encodeURIComponent(query)}`);
    return response.data;
  },

  bulkCreate: async (diseases: Omit<Disease, 'id' | 'createdAt' | 'updatedAt' | 'group' | 'medicines'>[]): Promise<Disease[]> => {
    const response = await api.post<Disease[]>('/diseases/bulk', { diseases });
    return response.data;
  },
}; 